/* eslint-disable @typescript-eslint/no-explicit-any */
import { LabelSeriesPoint } from 'generated/signals-graphql';
import React from 'react';
import { ComposableMap, Geographies, Geography } from 'react-simple-maps';
import topo from './usa.topo.json';
import { DistributionGainsType } from 'utils/types';

const gainFills = {
  HIGH: '#51a3f6',
  MEDIUM_HIGH: '#8cc3f9',
  MEDIUM: '#acd5fb',
  MEDIUM_LOW: '#c7e3fc',
  LOW: '#eff9fe',
};

const lossFills = {
  HIGH: '#e3797b',
  MEDIUM_HIGH: '#e99596',
  MEDIUM: '#efb1b2',
  MEDIUM_LOW: '#f6d4d4',
  LOW: '#fdf6f6',
};

const getFill = (number: number, max: number, type: string) => {
  const fills = type === DistributionGainsType ? gainFills : lossFills;
  const num = Math.abs(number);
  if (num === 0) return '#ffffff';
  if (num <= max * 0.2) return fills.LOW;
  if (num <= max * 0.4) return fills.MEDIUM_LOW;
  if (num <= max * 0.6) return fills.MEDIUM;
  if (num <= max * 0.8) return fills.MEDIUM_HIGH;
  if (num > max * 0.8) return fills.HIGH;
  return 'DEFAULT';
};

interface Props {
  data: LabelSeriesPoint[];
  setTooltipContent: Function;
  typeOfDistribution: string;
}

const MapChart: React.FC<Props> = ({ data, typeOfDistribution, setTooltipContent }) => {
  const amounts = data.map((item: LabelSeriesPoint) => {
    return Math.abs(item?.amount);
  });

  const maxAmount = Math.abs(Math.max.apply(null, amounts));

  return (
    <ComposableMap data-tip="" projection="geoAlbersUsa" className="map-box__height">
      <Geographies geography={topo}>
        {({ geographies }) =>
          geographies.map((geo) => {
            const cur = data.find((s: any) => s.label === geo.id);
            return (
              <Geography
                key={geo.rsmKey}
                geography={geo}
                onMouseEnter={() => {
                  if (geo && cur) {
                    setTooltipContent(`${geo.properties.name}: ${cur.amount}`);
                  }
                }}
                onMouseLeave={() => {
                  setTooltipContent('');
                }}
                fill={getFill(cur?.amount || 0, maxAmount, typeOfDistribution)}
                style={{
                  default: {
                    stroke: '#9c9c9c',
                    strokeWidth: 0.75,
                    outline: 'none',
                    transition: 'all 250ms',
                  },
                  hover: {
                    fill: 'rgb(252, 141, 89)',
                    stroke: 'rgb(223, 223, 223)',
                    strokeWidth: 2,
                    strokeOpacity: 1,
                    outline: 'none',
                    transition: 'all 250ms',
                  },
                  pressed: {
                    outline: 'none',
                  },
                }}
              />
            );
          })
        }
      </Geographies>
    </ComposableMap>
  );
};

export default React.memo(MapChart);
